/**
 * Joined Elite Force country defense: the owner plays their Attack Strategy vs the attacker.
 * No battle_rewards are defined for this fight (HQ joined battles still have mission rewards).
 *
 * @param {object | null | undefined} gameState
 * @returns {boolean}
 */
export function isEliteForceJoinedCountryBattle(gameState) {
  if (!gameState) {
    return false;
  }
  if (gameState.warEffortEliteDefenseJoined !== true) {
    return false;
  }
  if (gameState.warEffortBattleType !== 'fortified_country') {
    return false;
  }
  return true;
}
